export default class productListCtrl {
    constructor($scope, $http, $rootScope, $compile, bsLoadingOverlayService) {
        'ngInject';

        $scope.nextpage = 1;
        $scope.alterGETparam = function (param, value) {
            var newURL = $scope.updateURLParameter(window.location.href, param, value);
            newURL = $scope.updateURLParameter(newURL, param, value);
            window.history.replaceState('', '', $scope.updateURLParameter(window.location.href, param, value));
        }
        
        $scope.updateURLParameter = function(url, param, paramVal) {
            var TheAnchor = null;
            var newAdditionalURL = "";
            var tempArray = url.split("?");
            var baseURL = tempArray[0];
            var additionalURL = tempArray[1];
            var temp = "";
        
            if (additionalURL) {
                var tmpAnchor = additionalURL.split("#");
                var TheParams = tmpAnchor[0];
                TheAnchor = tmpAnchor[1];
                if (TheAnchor) additionalURL = TheParams;
        
                tempArray = additionalURL.split("&");
        
                for (var i = 0; i < tempArray.length; i++) {
                    if (tempArray[i].split('=')[0] != param) {
                        newAdditionalURL += temp + tempArray[i];
                        temp = "&";
                    }
                }
            } else {
                var tmpAnchor = baseURL.split("#");
                var TheParams = tmpAnchor[0];
                TheAnchor = tmpAnchor[1];
        
                if (TheParams) baseURL = TheParams;
            }
        
            if (TheAnchor) paramVal += "#" + TheAnchor;
        
            var rows_txt = temp + "" + param + "=" + paramVal;
            return baseURL + "?" + newAdditionalURL + rows_txt;
        }

        $scope.searchForm = {};

        $scope.q = {};
        $scope.q.category = [];

        $scope.showClear = false;

        $scope.searchProducts = function () {
            $('#products-list').fadeOut();
            bsLoadingOverlayService.start();
            var postParams = {};
            postParams = $scope.q;
            if (postParams.category.length > 0) {
                if (postParams.category instanceof Array) {
                    postParams.category = postParams.category.join(',');
                } else {
                    postParams.category = postParams.category;
                }

            }

            $http({
                method: "GET",
                url: "/search?" + $rootScope.params(postParams),

            }).then(function (data) {

                var newContent = $(data.data).find('#products-list').html();
                var newHeader = $(data.data).find('#products-header').html();



                $('#products-list').html($compile(newContent)($scope));
                $('#products-header').html($compile(newHeader)($scope));

                productListView();
                $('#products-list').fadeIn();
                bsLoadingOverlayService.stop();

            });
        }

        $scope.toggleSelection = function toggleSelection(val) {

            if ($scope.q.category instanceof Array) {

            } else {
                var tmp = $scope.q.category;
                $scope.q.category = [];
                $scope.q.category = tmp.split(',');
            }

            var idx = $scope.q.category.indexOf(val);

            // Is currently selected
            if (idx > -1) {
                $scope.q.category.splice(idx, 1);

            }

            // Is newly selected
            else {
                $scope.q.category.push(val);
            }
        };

        $scope.$watch('q.pmin', function () {
            if (typeof $scope.q.pmin != 'undefined') {
                $scope.alterGETparam('pmin', $scope.q.pmin);
                $scope.showClear = true;
            }
        });

        $scope.$watch('q.pmax', function () {
            if (typeof $scope.q.pmax != 'undefined') {
                $scope.alterGETparam('pmax', $scope.q.pmax);
                $scope.showClear = true;
            }
        });

        $scope.$watchCollection('q.category', function () {
            if ($scope.q.category.length > 0) {
                try {
                    $scope.alterGETparam('category', $scope.q.category.join(','));
                } catch (e) {

                }

            }

        });

        $scope.getUrlParameter = function (name) {
            var results = new RegExp('[\\?&]' + name + '=([^&#?]*)').exec(window.location.href);
            if (results == null) {
                return null;
            } else {
                return results[1] || 0;
            }
        }

        try {
            $scope.q.category = $scope.getUrlParameter('category').split(',');
        } catch (e) {

        }

        $scope.nView = 4;
        $scope.productListView = function (nView) {
            var elements = $("#products-list").find("[class^=col-]");
            var defaultView = elements.attr('class');
            $(elements).removeClass();

            if (nView == 4) {
                $(elements).addClass("col-md-4 col-sm-8 col-16");
            } else if (nView == 2) {
                $(elements).addClass("col-sm-8 col-16");
            } else if (nView == 1) {
                $(elements).addClass("col-md-8 col-16");
            }

            $scope.alterGETparam('nvt', nView);
            $scope.nView = nView;
        }
        $scope.thispage = 1;
        $scope.nextpage = 2;
        $scope.loadMore = function (_url) {
            bsLoadingOverlayService.start();
            $http({
                method: "GET",
                url: _url
            }).then(function (success) {
                    var result = success.data;
                    if ($(result).find('#loadMoreBtn').length == 0) {
                        $('#loadMoreBtn').hide();
                    } else {
                        $('#loadMoreBtn').show();
                    }
                    $('#products-list').append($(result).find('#products-list').html());
                    $('#loadMoreBtn').html($compile($(result).find('#loadMoreBtn').html())($scope));
                    bsLoadingOverlayService.stop();
                    $scope.alterGETparam('page', $scope.nextpage);
                    $scope.alterGETparam('ltp', 1);
                    $scope.nextpage++;
            }, 
            function(error){

            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/eshop/Controllers/08.products.list.ctrl.js